import type { AxiosError } from "axios";

import instance from "..";

interface RecoveryCode {
  code: string;
}

/**
 * Try the legacy /accounts/{cognitoId}/account-recovery path first, then
 * fall back to /owner/account-recovery. Once gobroker ships the /owner
 * endpoint everywhere, the legacy branch can be removed.
 */
async function recoveryMutate<T = RecoveryCode>(
  method: "post" | "delete",
  cognitoId: string,
): Promise<T> {
  const paths = [
    `/accounts/${cognitoId}/account-recovery`,
    "/owner/account-recovery",
  ];

  let lastErr: unknown;
  for (const path of paths) {
    try {
      const res = await instance[method]<T>(path);
      return res.data;
    } catch (e) {
      lastErr = e;
      const status = (e as AxiosError)?.response?.status;
      if (status === 404 || status === 401) {
        continue;
      }
      throw e;
    }
  }
  throw lastErr;
}

export const createRecoveryCode = (cognitoId: string): Promise<RecoveryCode> =>
  recoveryMutate("post", cognitoId);

export const deleteRecoveryCode = (cognitoId: string): Promise<void> =>
  recoveryMutate("delete", cognitoId);
